import React from "react";
import AddressSearch from "../AddressSearch";

// Compact dark-blue valuation lead-capture banner for blog pages.
export const BlogValuationBanner = ({ compact = false }) => (
  <section
    data-testid="blog-valuation-banner"
    className="bg-brand-dark border-b border-white/10"
  >
    <div className={`mx-auto max-w-5xl px-5 sm:px-8 ${compact ? "py-8 sm:py-10" : "py-10 sm:py-12"}`}>
      <span className="eyebrow text-brand-gold">Free · Instant · Multi-AI &amp; 3-Portal AVM</span>
      <h2 className="mt-2 font-serif font-light leading-[1.1] text-2xl sm:text-3xl lg:text-4xl text-white">
        Curious What Your Silicon Valley Home Is Worth?
      </h2>
      <p className="mt-2 text-sm sm:text-base text-white/70 max-w-2xl leading-relaxed">
        Benchmark 3 portals &amp; a multi-model AI panel in seconds — with your real net equity at a 1% listing fee.
      </p>
      <div className="mt-5">
        <AddressSearch />
      </div>
    </div>
  </section>
);

export default BlogValuationBanner;
